export default __webpack_public_path__ + "static/media/CTAImagePlus.ebc4dde1.jpg";